// API Endpoints
export const GENERAL = {
    NAME: "Democratic Chess",
    VERSION: "1.0.0",
    SERVER_URL_HTTP: "ws://localhost:8080/game/ws",
    SERVER_URL_HTTPS: "wss://api.democraticchess.com/game/ws", //"wss://middle-goose-democraticchess-81d6dac7.koyeb.app/game/ws",//"wss://democraticchess.duckdns.org/game/ws", 
    HOST: "https://democraticchess.com/",
    SHARE_IMAGE: "https://landing.democraticchess.com/img/about.webp",
    BACKGROUND: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743414461/Pictures/wmmklcskexrcb7b5zutp.jpg",

    languageOptions: [
      {
        code: "en",
        name: "English",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405788/Pictures/ciqsflhvjmllwogcd2fg.svg",
      },
      {
        code: "es",
        name: "Español",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405804/Pictures/inkvrpfdyiaabnctm8ed.svg",
      },
      {
        code: "fr",
        name: "Français",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405800/Pictures/v4eywrpsipssvo3hfwnl.svg",
      },
      {
        code: "de",
        name: "Deutsch",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405799/Pictures/cid5fq7hgggulif5wrrc.svg",
      },
      {
        code: "zh",
        name: "中文",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405797/Pictures/mk2cirsagiqs6e7b9tte.svg",
      },
      {
        code: "ru",
        name: "Русский",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405802/Pictures/iu2rtgtj5sjv6l4u4tvo.svg",
      },
      {
        code: "ja",
        name: "日本語",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405795/Pictures/lwvac5ho5pxezefq7vq6.svg",
      },
      {
        code: "pt",
        name: "Português",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405793/Pictures/eewedmumrzqkfcsfluzv.svg",
      },
      {
        code: "ar",
        name: "العربية",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405790/Pictures/xrtnkp0iobvqsgnll9db.svg",
      },
      {
        code: "hi",
        name: "हिन्दी",
        flag: "https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405792/Pictures/solvuww6nbm1mphtdosb.svg",
      },
    ],
  };
  
 